export default "__VITE_ASSET__DKGgcSCz__"